import { ScrollableTerms } from './scrollable-terms.component';

// Must be default exports for lazy loading
// eslint-disable-next-line import/no-default-export
export default ScrollableTerms;
